import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "video-container"
}
const _hoisted_2 = { class: "video-div" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "images-container"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 2,
  style: {"display":"flex","justify-content":"center","align-items":"center","height":"100vh","flex-direction":"column","text-align":"center"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Contenuto in visualizzazione esterna", -1)

import { IonIcon } from '@ionic/vue';

import {ref, onMounted} from 'vue';
import {ScreenOrientation} from "@awesome-cordova-plugins/screen-orientation";
import {getPlatforms} from '@ionic/vue';
import {Navigation, Pagination} from 'swiper';
import {Swiper, SwiperSlide} from "swiper/vue/swiper-vue";
import { arrowRedoOutline } from 'ionicons/icons';

// import 'swiper/css';
// import '@ionic/vue/css/ionic-swiper.css';



export default /*#__PURE__*/_defineComponent({
  props: {
  file: {
    type: Object,
    required: true,
  },
  orientation: {
    type: String,
    required: false,
    default: 'landscape'
  },
},
  setup(__props) {

const props = __props



const openLink = () => {
  window.open(props.file.link, '_blank')
}

onMounted(() => {
  if (props.file.type === 'link') {
    openLink()
  }
})

const modules = [Navigation, Pagination]

function isDesktop() {
  return getPlatforms().includes('desktop') || getPlatforms().includes('mobileweb');
}


if (props.file.type === 'video') {
  if (!isDesktop()) {
    // ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY)
  }
}

if (props.file.type === 'image') {
  if (!isDesktop()) {
    // ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT_PRIMARY)
  }
}

const orientationSettings = ref('landscape');

const slideOptions = {
  initialSlide: 0,
  speed: 400,
  direction: 'vertical'
}

function changeOrientation() {
  if (orientationSettings.value == 'landscape') {
    orientationSettings.value = 'portrait'
  } else {
    orientationSettings.value = 'landscape'
  }
}

return (_ctx: any,_cache: any) => {
  return (__props.file.type === 'video')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (!isDesktop())
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("iframe", {
                  src: `https://player.vimeo.com/video/${__props.file.link}?h=febc7f65a4&title=0&byline=0&portrait=0&speed=0&badge=0&autopause=0&player_id=0&app_id=58479&playsinline=0`,
                  frameborder: "0",
                  allow: "autoplay; fullscreen",
                  allowfullscreen: "",
                  webkitallowfullscreen: "",
                  mozallowfullscreen: "",
                  class: "vimeo-video"
                }, "\n        ", 8, _hoisted_3)
              ])
            ]))
          : (_openBlock(), _createElementBlock("iframe", {
              key: 1,
              src: `https://player.vimeo.com/video/${__props.file.link}?h=febc7f65a4&title=0&byline=0&portrait=0&speed=0&badge=0&autopause=0&player_id=0&app_id=58479&playsinline=0`,
              frameborder: "0",
              allow: "autoplay; fullscreen",
              allowfullscreen: "",
              webkitallowfullscreen: "",
              mozallowfullscreen: "",
              width: "100%",
              height: "100%"
            }, "\n    ", 8, _hoisted_4))
      ], 64))
    : (__props.file.type === 'image')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!isDesktop())
            ? (_openBlock(), _createBlock(_unref(Swiper), {
                key: 0,
                module: modules,
                direction: 'vertical',
                pagination: { clickable: true },
                navigation: "",
                "auto-height": "",
                class: "swiper"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.file.link, (link) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                      class: "swiper-slide",
                      key: link
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", { src: link }, null, 8, _hoisted_5)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "orientationSettings",
                  onClick: changeOrientation
                }, "RUOTA"),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.file.link, (link, index) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: index,
                    src: link,
                    class: _normalizeClass(orientationSettings.value)
                  }, null, 10, _hoisted_7))
                }), 128))
              ]))
        ], 64))
      : (__props.file.type === 'link')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("button", {
              class: "openLinkButton",
              onClick: openLink
            }, [
              _createVNode(_unref(IonIcon), {
                slot: "start",
                size: "large",
                ios: _unref(arrowRedoOutline),
                md: _unref(arrowRedoOutline)
              }, null, 8, ["ios", "md"])
            ])
          ]))
        : _createCommentVNode("", true)
}
}

})